export default "__VITE_ASSET__DxQ22IzM__"